import { Button, Checkbox, Stack, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';

import { AppContext } from '../../../../../App';
import { useFoodComponentStationAction } from '../../../../../hooks';
import { CombinedShortages, CookingStationName, FoodComponent, FoodComponentStationOperation } from '../../../../../libs';

type ActionButtonsProps = {
  foodComponent: FoodComponent;
  tableName: CookingStationName;
  statusAttributes: {
    isCheckable: boolean;
    lastUncheckedStation: string;
  };
} & (
  | {
      combinedShortages: CombinedShortages;
      isChecked: boolean;
      setIsCheckedState: React.Dispatch<React.SetStateAction<boolean>>;
    }
  | { combinedShortages: undefined }
);

const ActionButtons = ({ foodComponent, tableName, statusAttributes, ...props }: ActionButtonsProps) => {
  const appContext = useContext(AppContext);
  const theme = useTheme();

  const { handleFoodComponentStationAction, loading } = useFoodComponentStationAction({
    foodComponent,
    tableName,
    shortagesIds: props.combinedShortages?.ids ?? [],
    updatePortioningStatus: !props.combinedShortages
  });

  if (props.combinedShortages) {
    return (
      <Checkbox
        sx={{ mr: '30px' }}
        checked={props.isChecked}
        disabled={!statusAttributes.isCheckable || loading || appContext.isOffline || props.isChecked}
        onChange={(event) => {
          if (!props.isChecked) {
            props.setIsCheckedState(event.target.checked);
            void handleFoodComponentStationAction(FoodComponentStationOperation.end);
          }
        }}
        slotProps={{
          input: { 'aria-label': 'controlled' }
        }}
      />
    );
  }

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'column',
        my: '-4px',
        alignItems: 'center'
      }}
    >
      <Button
        onClick={() => void handleFoodComponentStationAction(FoodComponentStationOperation.end)}
        disabled={!statusAttributes.isCheckable || loading || appContext.isOffline}
        variant="contained"
        sx={{
          width: '110px',
          height: '100%',
          color: theme.palette.white,
          border: '1px solid ' + theme.palette.primary500,
          borderRadius: '4px',
          textTransform: 'capitalize',
          '&:disabled': {
            borderColor: theme.palette.neutral200
          }
        }}
      >
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '13px'
          }}
        >
          DONE
        </Typography>
      </Button>
    </Stack>
  );
};

export default ActionButtons;
